import { render, staticRenderFns } from "./field-selector.vue?vue&type=template&id=6ae2ca98&"
import script from "./field-selector.vue?vue&type=script&lang=ts&"
export * from "./field-selector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports